export default __webpack_public_path__ + "static/O0313-707579e5498e8eeb07505bbcdc4751d5.png";